import { makeStyles } from '@material-ui/core/styles'
import { GRAY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  filter: {
    width: '100%',
    margin: 0,
    padding: 12,
    borderRadius: 12,
    backgroundColor: GRAY_COLORS[50],
    marginBottom: 20
  }
}))
